<p-card [header]="title" class="h-100 custom-shadow">
  <ng-content></ng-content>
</p-card>
